import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageInterface, UserMenuItems } from 'src/app/services/config/menu';
import { CoreProvider } from 'src/app/services/core';

@Component({
  selector: 'cpnt-profile-popover',
  templateUrl: './profile-popover.component.html',
  styleUrls: ['./profile-popover.component.scss'],
})
export class ProfilePopoverComponent implements OnInit {
  menuModel = UserMenuItems;
  options: PageInterface[]

  constructor(private router: Router, public core: CoreProvider) { }

  ngOnInit() {
    this.menuModel.forEach(e => {
      if (e.header == "Other") {
        this.options = e.items;
      }
    });
  }

  logout() {
    this.core.auth.logout(() => {
      // this.core.setRoot(LoginPage, {});
      this.router.navigateByUrl('/login');
    });
  }

  isActive(page: PageInterface) {
    if (this.router && this.router.isActive(page.url, true)) {
      return "selected-icon";
      // return page.color ? page.color : 'icons';
    }
    return;
  }

  dismiss() {
    this.core.popoverCtrl.dismiss();
  }
}
